import { render, staticRenderFns } from "./game-2.vue?vue&type=template&id=4fe5699b&scoped=true&"
import script from "./game-2.vue?vue&type=script&lang=js&"
export * from "./game-2.vue?vue&type=script&lang=js&"
import style0 from "./game-2.vue?vue&type=style&index=0&id=4fe5699b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5699b",
  null
  
)

export default component.exports